// Generated types for SourceDocument
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SourceDocumentType } from '../enums';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SourceDocumentReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** Precise reference within the source (e.g. 'MRS-PTPU-II §4.3', 'ATEX 2014/34/EU Annex II clause 1.2'). */
  citation?: string | null;
  /** Kind of source — drives provenance weight at review time. */
  document_type?: SourceDocumentType;
  /** Link to the authoritative source if available online. */
  url?: string | null;
  /** Free-form date string (e.g. '2014', '2023-06-15'). Kept as a string to tolerate partial / ISO / informal forms; structured parsing is deferred to phase 2. */
  publication_date?: string | null;
}

export interface SourceDocumentWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** Precise reference within the source (e.g. 'MRS-PTPU-II §4.3', 'ATEX 2014/34/EU Annex II clause 1.2'). */
  citation?: string | null;
  /** Kind of source — drives provenance weight at review time. */
  document_type?: SourceDocumentType;
  /** Link to the authoritative source if available online. */
  url?: string | null;
  /** Free-form date string (e.g. '2014', '2023-06-15'). Kept as a string to tolerate partial / ISO / informal forms; structured parsing is deferred to phase 2. */
  publication_date?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SourceDocumentReadAPISchema: z.ZodType<SourceDocumentReadAPI> = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  citation: z.string().nullable().optional(),
  document_type: z.nativeEnum(SourceDocumentType).optional(),
  url: z.string().nullable().optional(),
  publication_date: z.string().nullable().optional(),
}).passthrough();

export const SourceDocumentWriteAPISchema: z.ZodType<SourceDocumentWriteAPI> = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  citation: z.string().nullable().optional(),
  document_type: z.nativeEnum(SourceDocumentType).optional(),
  url: z.string().nullable().optional(),
  publication_date: z.string().nullable().optional(),
}).passthrough();
